import { render } from "./WhatsappFloat.vue?vue&type=template&id=fcab8006"
import script from "./WhatsappFloat.vue?vue&type=script&lang=js"
export * from "./WhatsappFloat.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__